import { render } from "./InlineNotification.vue?vue&type=template&id=776fabbc"
import script from "./InlineNotification.vue?vue&type=script&lang=js"
export * from "./InlineNotification.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./less/nofitication.less?vue&type=style&index=0&module=true&lang=css&external"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__